import { render, staticRenderFns } from "./BestEducation.vue?vue&type=template&id=90794e82&scoped=true&"
import script from "./BestEducation.vue?vue&type=script&lang=ts&"
export * from "./BestEducation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90794e82",
  null
  
)

export default component.exports